import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"

import {Query as QueryComponent} from "../"

export const query = gql`
  query CycleResponseCount(
    $tenant: String!, 
    $id: String!, 
    $team: String = "",
    $minOpenedAt: String = ""
  ) {
    schedule(tenant: $tenant, id: $id) {
      id
      responseCount(team: $team, surveyOpenedAfter: $minOpenedAt)
    }
  }`

const CycleResponseCountQuery = ({children, ...props}) => {
  return (
    <QueryComponent
      {...props}
      query={query}>
      {({data: {schedule = {}} = {}, ...apolloState}) => {
        const {responseCount = NaN} = schedule
        return children({responseCount, ...apolloState})
      }}
    </QueryComponent>
  )
}

CycleResponseCountQuery.propTypes = {
  children: PropTypes.func.isRequired
}


export default CycleResponseCountQuery
